import React, { memo } from 'react';
import { ImageErrorPlaceholder } from '@yme/atoms/image-error-placeholder';
import { ShowMore } from '@yme/atoms/show-more';
import { useIsMount, useRenditions } from '@yme/hooks/index';
import { colorCoreBlack300 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { INDENT } from '@yme/tokens/sizes';
import { RegularTextLevel2, RegularTextLevel3 } from '@yme/tokens/typography';
import { AspectRatio } from '@yme/utils/constants';
import { FeaturesItemCardStyled, ImageWrapperStyled, ImageStyled, DescriptionStyled, HeadingLevel3Styled, } from './styled';
function FeaturesItemCardComponent(props) {
    const { isRightToLeft = false, isDescriptionCollapsing = false, labels, cardProps } = props;
    const { title, alt = '', imageUrl, description, isH3Title } = cardProps;
    const { imageSrcWithDimension } = useRenditions({
        imageSrc: imageUrl || '',
    });
    const isMount = useIsMount();
    const isContentWithCollapsing = Boolean(isDescriptionCollapsing && labels?.common_showLess_button && labels?.common_showMore_button);
    const shouldShowMoreComponent = !isMount && description && isContentWithCollapsing;
    const shouldShowDescription = description && !isContentWithCollapsing;
    return (React.createElement(FeaturesItemCardStyled, { isRightToLeft: isRightToLeft, flexDirection: "column" },
        imageUrl ? (React.createElement(ImageWrapperStyled, null,
            React.createElement(ImageStyled, { className: "features-item-card-image", alt: alt || title, src: imageSrcWithDimension, fallbackSrc: imageUrl, aspectRatio: AspectRatio.RectangleLevel3, isLazyLoadImage: true }))) : (React.createElement(FlexWrapper, { mb: INDENT.xs },
            React.createElement(ImageErrorPlaceholder, { hasBackground: true }))),
        title && (React.createElement(FlexWrapper, { mb: INDENT.xxxs }, isH3Title ? (React.createElement(HeadingLevel3Styled, null, title)) : (React.createElement(RegularTextLevel2, { weight: 500 }, title)))),
        shouldShowMoreComponent && (React.createElement(FlexWrapper, null,
            React.createElement(ShowMore, { maxLinesCount: 3, labelShowLess: labels?.common_showLess_button, labelShowMore: labels?.common_showMore_button, wrapper: DescriptionStyled }, description))),
        shouldShowDescription && (React.createElement(FlexWrapper, null,
            React.createElement(RegularTextLevel3, { weight: 400, color: colorCoreBlack300 }, description)))));
}
export const FeaturesItemCard = memo(FeaturesItemCardComponent);
FeaturesItemCard.displayName = 'FeaturesItemCard_Component';
